import Fetcher from '../../common/util/Fetcher';
import withDynamoPagination from '../../common/util/withDynamoPagination';
import { handleQuizSessionEventsResponse } from '../../common/api/callHandlers';
import { QUIZ_SESSION_EVENTS_FETCH_CALL } from '@instructure/quiz-common';
export function getQuizSessionEvents(quizSessionId, launchToken) {
  var url = "/api/quiz_sessions/".concat(quizSessionId, "/quiz_session_events");
  var fetcher = Reflect.construct(withDynamoPagination(Fetcher, launchToken ? {
    launchToken: launchToken
  } : {}), [{
    callType: QUIZ_SESSION_EVENTS_FETCH_CALL
  }]);
  return function (dispatch, getState) {
    return fetcher.paginatedGet(url, {
      actionCreator: handleQuizSessionEventsResponse
    });
  };
}